import {Fragment, PureComponent} from 'react'

import './FilterType.scss'

export default class FilterType extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      type: props.type,
    }
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (this.props.type !== prevProps.type) {
      this.setState({
        type: this.props.type
      })
    }
  }

  onChecked = (event) => {
    const target = event.target
    const value = target.checked
    const name = target.name

    let newType
    if (value) {
      newType = (this.state.type | name) >>> 0
    } else {
      newType = (this.state.type & ~(name)) >>> 0
    }

    this.props.onChange(newType)
    this.setState({
      type: newType
    })
  }

  render() {
    const {topologies} = this.props

    return <Fragment>
      {topologies.map((item, key) => {
        return <div key={key} className="row">
          <div className="col-6">
            <label>
              <input
                id={key + item[0].name}
                type="checkbox"
                name={item[0].value}
                onChange={this.onChecked}
                checked={this.state.type & item[0].value}
              />
              <span> {item[0].label}</span>
            </label>
          </div>
          {item[1] &&
            <div className="col-6">
              <label>
                <input
                  id={key + item[1].name}
                  type="checkbox"
                  name={item[1].value}
                  onChange={this.onChecked}
                  checked={this.state.type & item[1].value}
                />
                <span> {item[1].label}</span>
              </label>
            </div>
          }
        </div>
      })}
    </Fragment>
  }
}